export default {
    VIEWPORT_DEFAULT_VALUE: '-1'
};
